function getElementDimensions(element = null) {
  if (!element) return;

  const elementDom = document.querySelector(element);
  const rect = elementDom.getBoundingClientRect();
  return rect;
}

export { getElementDimensions as g };
